import { LinkHash } from '@/components/common/Link'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type IconType } from '@/defs/icon'
import { cn } from '@/utils/commonUtil'

import styles from './NavSidebar.module.scss'

type Props = {
  numbered?: boolean
  sections?: {
    icon: IconType
    items: {
      icon?: IconType
      isSelected?: boolean
      label: string
      slug: string
    }[]
    label: string
  }[]
  variant?: 'solid'
}

export const NavSidebar = ({ numbered = true, sections, variant }: Props) => {
  const Tag = numbered ? 'ol' : 'ul'

  return (
    <ul className={cn(styles.container, { numbered, styles, variant })}>
      {sections?.map((s, i) => (
        <li key={i}>
          <div className={styles.sectionLabel}>
            <IconWithLabel iconBefore={s.icon} wrapNone>
              {s.label}
            </IconWithLabel>
          </div>
          <Tag>
            {s.items.map(({ icon, isSelected, label, slug }, j) => (
              <li key={j}>
                <LinkHash className={cn(styles.itemLabel, { isSelected, styles })} hash={slug}>
                  <IconWithLabel iconBefore={icon}>{label}</IconWithLabel>
                </LinkHash>
              </li>
            ))}
          </Tag>
        </li>
      ))}
    </ul>
  )
}
